module.exports = __webpack_public_path__ + "media/images/webpage/hotels/743/plan2-1-da41855b20143a1ebf5db3ffe1bb53c5.webp";